import React, { useState } from 'react';
import { RedesignCalloutBlock } from '../../models/tcsm-block-models';
import { WysiwygWithReactLink } from '../wysiwyg-with-react-link';
import { VideoModal } from '../video-modal';

interface Props {
	blockData: RedesignCalloutBlock,
}

export function RedesignCalloutBlockView(props: Props) {

	const { blockData } = props;

	const [videoOpen, setVideoOpen] = useState(false);

	function getVideoEmbedUrl(): string {
		if (blockData.youtubeID) {
			return `https://www.youtube.com/embed/${blockData.youtubeID}?rel=0&showinfo=0${blockData.youtubeAutoPlay ? '&autoplay=1' : ''}`;
		}
		if (blockData.vimeoID) {
			return `https://player.vimeo.com/video/${blockData.vimeoID}`;
		}
		return blockData.videoReference || '';
	}

	const videoEmbedUrl = getVideoEmbedUrl();

	function RenderContent() {
		return (
			<div className="smallblock-content">
				{blockData.pretitle && <p className="pretitle">{blockData.pretitle}</p>}
				{blockData.title && (
					blockData.titleLink
						? <h2 className="h1-style"><a href={blockData.titleLink}>{blockData.title}</a></h2>
						: <h2 className="h1-style">{blockData.title}</h2>
				)}
				{blockData.summary && (
					<div className="rich-text smallblock-description">
						<WysiwygWithReactLink content={blockData.summary} />
					</div>
				)}
				{blockData.ctaText && blockData.ctaLink && (
					<div className="smallblock-cta">
						<a href={blockData.ctaLink} className="btn-secondary">{blockData.ctaText}</a>
					</div>
				)}
				{blockData.relatedLinks && blockData.relatedLinks.length > 0 && (
					<div className="smallblock-links">
						{blockData.relatedLinks.map((link, index) => (
							<React.Fragment key={`${link.friendlyUrl}-${index}`}>
								{index > 0 ? '|' : ''}
								<a href={link.friendlyUrl}>{link.title}</a>
							</React.Fragment>
						))}
					</div>
				)}
			</div>
		);
	}

	function RenderMedia() {
		if (!blockData.thumbnail) {
			return null;
		}

		const image = <img src={blockData.thumbnail} alt={blockData.thumbnailAltText || ''} />;

		let media = image;
		if (videoEmbedUrl) {
			media = (
				<a
					href={videoEmbedUrl}
					className="smallblock-video-link"
					onClick={(e) => { e.preventDefault(); setVideoOpen(true); }}
				>
					<span className="visually-hidden">Click to expand video modal</span>
					{image}
					<svg className="svg-icon" aria-hidden="true" focusable="false">
						<use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#play-icon" />
					</svg>
				</a>
			);
		} else if (blockData.thumbnailLink) {
			media = <a href={blockData.thumbnailLink}>{image}</a>;
		}

		return (
			<div className="smallblock-image">
				{media}
			</div>
		);
	}

	const mediaFirst = blockData.alignment?.toLowerCase() === 'left';

	return (
		<section className="adage-block callout-block">
			<div className="block-inner smallblock-inner">
				{mediaFirst ? (
					<>
						{RenderMedia()}
						{RenderContent()}
					</>
				) : (
					<>
						{RenderContent()}
						{RenderMedia()}
					</>
				)}
			</div>
			<VideoModal open={videoOpen} onClose={() => setVideoOpen(false)} embedUrl={videoEmbedUrl} />
		</section>
	);
}

export default RedesignCalloutBlockView;
